import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatList, MatListItemTitle } from '@angular/material/list';
import { ShippingMethodPipe } from '../../../core/pipes/shipping-method.pipe';
import { RedemptionResponse } from '../../../core/Interfaces/Http/redemption-response';
import { ProductItemComponent } from '../product-item/product-item.component';

@Component({
  selector: 'app-delivery',
  imports: [
    DatePipe,
    MatCard,
    MatCardContent,
    MatList,
    MatListItemTitle,
    ShippingMethodPipe,
    ProductItemComponent,
  ],
  templateUrl: './delivery.component.html',
  styleUrl: './delivery.component.scss',
})
export class DeliveryComponent {
  @Input() redemption!: RedemptionResponse;
}
